import { Component, OnInit, Input, OnChanges, HostListener, OnDestroy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { McatalogConfigService } from 'src/app/services/catalogs-services/config-services/mcatalog-config.service';

@Component({
  selector: 'app-catalogs-config-services-card',
  templateUrl: './catalogs-config-services-card.component.html',
  styleUrls: ['./catalogs-config-services-card.component.scss']
})
export class CatalogsConfigServicesCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() services;
  editingLocked;
  showForm: boolean;
  updateCatalogConfigSubscription: Subscription;

  basicDataForm = new FormGroup({});

  constructor(private mcatalogConfigService: McatalogConfigService,
              private snackbarService: SnackBarService,
              private cd: ChangeDetectorRef,
              private eRef: ElementRef) {
                this.editingLocked = true;
              }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.services) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.services && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      this.submitForm();
      this.lockEdition();
    }
  }

  public submitForm() {
    const internalIds = [];
    Object.entries(this.basicDataForm.value).map(v => {if (v[1] === true) { internalIds.push(v[0]); }});
    this.updateCatalogConfigSubscription = this.mcatalogConfigService.updateMCatalogServices(internalIds).subscribe(
      (res) => {
        this.editingLocked = true;
        this.snackbarService.open('catalogs-page.snackbar messages.update services success', 'success');
        this.mcatalogConfigService.refreshMCatalogConfig();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
        this.mcatalogConfigService.refreshMCatalogConfig();
      }
    );
  }

  public resetForm() {
    this.showForm = false;
    this.services.forEach(s => {
      this.basicDataForm.addControl(s.InternalId, new FormControl({value: s.Active, disabled: true}));
    });
    this.showForm = true;
    this.cd.detectChanges();
  }

  public unlockEdition() {
    this.basicDataForm.enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.disable();
    this.editingLocked = true;
  }

  ngOnDestroy() {
  }

}
